import {GenericWalletAdapter} from './GenericWalletAdapter'
import {XWalletConnectConfig} from '@/config/XWalletConnectConfig'
import {WalletPlatform} from '@/enums/WalletPlatform'
import {NeonWalletAdapter} from '@/model/wallets/adapters/NeonWalletAdapter'

export class NeonXWalletAdapter extends NeonWalletAdapter
  implements GenericWalletAdapter {
  platform: WalletPlatform = WalletPlatform.NEON

  constructor() {
    super(XWalletConnectConfig.network, XWalletConnectConfig.methods)
  }

  async invoke(params: any): Promise<string> {
    const request = {
      method: 'eth_sendTransaction',
      params: [{...params}],
    }

    const transactionHash = await this.sendRequest(request)

    return transactionHash
  }
}
